function notifyHomepageLiveEmbedError(error) {
  try {
    if (window.Bugsnag && typeof window.Bugsnag.notify === "function") {
      window.Bugsnag.notify(error, function(event) {
        event.context = "Twitch embed initialization failed";
        if (typeof event.addMetadata === "function") {
          event.addMetadata("homepageLiveEmbed", {
            message: error && error.message,
          });
        }
      });
      return;
    }

    if (window.console && typeof window.console.error === "function") {
      window.console.error("Twitch embed initialization failed", error);
    }
  } catch (_innerError) {
    // Protect the global on-ready loop even if Bugsnag/console reporting fails.
  }
}

function renderTwitchEmbed(container) {
  if (!window.Twitch || typeof window.Twitch.Embed !== "function") return;

  container.innerHTML = "";
  new window.Twitch.Embed("twitch-embed", {
    width: 720,
    height: 550,
    layout: "video",
    channel: "mtggoldfish",
    parent: ["www.mtggoldfish.com", "staging.mtggoldfish.com"],
  });
}

function renderYoutubeEmbed(container) {
  container.innerHTML = '<iframe width="720" height="550" src="https://www.youtube.com/embed/live_stream?channel=UCXiENZMcmp6CGj37bVYQAqA&autoplay=1&mute=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
}

function initHomepageLiveEmbed() {
  try {
    var twitchContainer = document.getElementById("twitch-embed");
    var youtubeContainer = document.getElementById("youtube-embed");

    if (window.innerWidth <= 1150) return;

    // The controller renders exactly one live-feature container. This is an
    // editorial choice, not a client-side Twitch-to-YouTube fallback chain.
    if (twitchContainer) {
      renderTwitchEmbed(twitchContainer);
    } else if (youtubeContainer) {
      renderYoutubeEmbed(youtubeContainer);
    }
  } catch (error) {
    notifyHomepageLiveEmbedError(error);
  }
}

window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.initHomepageLiveEmbed = initHomepageLiveEmbed;

export { initHomepageLiveEmbed };
